export default {"src":"/_next/static/media/ax.9d06a60a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};